import Colors from '../../../../Configs/colors';

const styles = {
  preview: {
    '& .storage': {
      height: 24,
      width: 24,
      borderRadius: 4,
      boxSizing: 'border-box',
      '&.available': {
        background: '#7ccfbd',
      },
      '&.not_available': {
        background: Colors.primary,
      },
      '&.empty': {
        background: 'transparent',
        border: '1px solid #ABB1BB',
      },
      '&.pointer': {
        cursor: 'pointer',
      },
      '&.selected': {
        background: '#E87A46',
        border: '2px solid #BB6238',
      },
    },
  },
  root: {
    paddingBottom: 16,
    '& .storage': {
      height: 40,
      width: 40,
      borderRadius: 4,
      boxSizing: 'border-box',
      '&.available': {
        background: '#7ccfbd',
      },
      '&.not_available': {
        background: Colors.primary,
      },
      '&.empty': {
        background: 'transparent',
        border: '1px solid #ABB1BB',
      },
      '&.pointer': {
        cursor: 'pointer',
      },
      '&.selected': {
        background: '#E87A46',
        border: '2px solid #BB6238',
      },
    },
    '& aside': {
      backgroundColor: Colors.white,
      padding: 16,
      paddingTop: 0,
      borderRadius: 8,
      height: '100vh',
      boxSizing: 'border-box',
      overflow: 'auto',
      border: '1px solid #DADADA',
      '::-webkit-scrollbar': {
        display: 'none !important',
      },
      '-ms-overflow-style': 'none', /* IE and Edge */
      'scrollbar-width': 'none', /* Firefox */
      '& .box-info': {
        width: '100%',
        padding: '16px 12px',
        border: '1px solid #E7E7E7',
        borderRadius: 8,
        boxSizing: 'border-box',
      },
    },
  },
  tabs: {
    '& :hover': {
      // color: colors.black1,
      opacity: 1,
    },
    '& .Mui-selected': {
      color: `${Colors.black} !important`,
      textTransform: 'none !important',
      fontWeight: '700 !important',
    },
    '& .Mui-focusVisible': {
      // backgroundColor: `${colors.black1} !important`,
    },
    '& .MuiTab-root': {
      textTransform: 'none !important',
      fontSize: 14,
      fontWeight: '400',
      paddingBottom: '2px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Colors.black,
    },
  },
  boxes: {
    '& .storage': {
      height: 40,
      width: 40,
      borderRadius: 4,
      boxSizing: 'border-box',
      '&.available': {
        background: '#7ccfbd',
      },
      '&.not_available': {
        background: Colors.primary,
      },
      '&.empty': {
        background: 'transparent',
        border: '1px solid #ABB1BB',
      },
      '&.pointer': {
        cursor: 'pointer',
      },
      '&.selected': {
        background: '#E87A46',
        border: '2px solid #BB6238',
      },
    },
  },
};

export default styles;
